
import React from "react";
import { ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface DesktopCategoriesProps {
  preachingImageUrl: string;
  passionsImageUrl: string;
}

const DesktopCategories = ({ preachingImageUrl, passionsImageUrl }: DesktopCategoriesProps) => {
  const navigate = useNavigate();
  
  const handleNavigate = (path: string) => {
    console.log("Desktop categories navigating to:", path);
    navigate(path);
  };
  
  return (
    <div className="flex justify-center w-full max-w-4xl mx-auto">
      <div className="grid grid-cols-2 gap-8 w-full">
        {/* First section - Leidenschaften */}
        <div className="w-full">
          <div className="bg-white/10 backdrop-blur-sm p-4 rounded-lg shadow-lg border border-white/20">
            <h4 className="text-base font-bold text-white text-center uppercase mb-3">
              MEINE LEIDENSCHAFTEN & HOBBIES
            </h4>
            <button 
              onClick={() => handleNavigate('/kurzueberblick')}
              className="group w-full relative rounded-lg overflow-hidden border border-white/20 transition-transform hover:scale-[1.02] h-[180px]"
            >
              <div className="aspect-video w-full h-full">
                <img
                  src={passionsImageUrl}
                  alt="Meine Leidenschaften & Hobbies"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors">
                  <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center animate-horizontal-bounce">
                    <ChevronRight className="w-4 h-4 text-white" />
                    <ChevronRight className="w-4 h-4 text-white -ml-2" />
                  </div>
                </div>
              </div>
            </button>
          </div>
        </div>
        
        {/* Second section - Predigt */}
        <div className="w-full">
          <div className="bg-white/10 backdrop-blur-sm p-4 rounded-lg shadow-lg border border-white/20">
            <h4 className="text-base font-bold text-white text-center uppercase mb-3">
              PREDIGT & POETRY SLAM
            </h4>
            <button 
              onClick={() => handleNavigate('/preaching')}
              className="group w-full relative rounded-lg overflow-hidden border border-white/20 transition-transform hover:scale-[1.02] h-[180px]"
            >
              <div className="aspect-video w-full h-full">
                <img
                  src={preachingImageUrl}
                  alt="Predigt & Poetry Slam"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors">
                  <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center animate-horizontal-bounce">
                    <ChevronRight className="w-4 h-4 text-white" />
                    <ChevronRight className="w-4 h-4 text-white -ml-2" />
                  </div>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesktopCategories;
